<template>
    <div class="aside-tag" v-if="list.length > 0">
        <div class="aside-tag__title">
            <span class="aside-tag__title-text">设计工具</span>
            <span class="aside-tag__title-more" @click="$router.push({ name: 'Tool' })">更多</span>
        </div>
        <div class="aside-tag__content">
            <div class="aside-tag__content-tag">
                <ul class="tag-list">
                    <li
                        v-for="(item, index) in list"
                        :key="index"
                        :class="item.color"
                        @click="handleTag(item)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { openWindow } from '@/utils/utils';
import { getToolList } from '@/api/home';

export default {
    name: 'AsideTag',
    data: () => ({
        list: []
    }),
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            getToolList().then(({ code, data }) => {
                if (code === 0) {
                    const colors = ['default', 'pink', 'green', 'blue'];
                    this.list = data.map((item, index) => {
                        return {
                            color: colors[index % 4],
                            ...item
                        };
                    });
                }
            });
        },
        handleTag(item) {
            // 平台内部链接
            if (item.isInside === 1) {
                openWindow('/#/tool/detail/' + item.contentId);
            } else if (item.isInside === 0 && item.url) {
                openWindow(item.url);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.aside-tag {
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(153, 154, 172, 0.07);
    border-radius: 4px;
    padding: 0 10px;

    &__title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        border-bottom: 1px solid #eef0fb;

        &-text {
            display: flex;
            align-items: center;
            @include font(rgba(39, 44, 64, 1), 16px, 600);

            &::before {
                content: '';
                display: inline-block;
                margin-right: 6px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: rgba(19, 194, 194, 1);
            }
        }

        &-more {
            @include font(#c0c4cc, 14px, 400);
            cursor: pointer;

            &:hover {
                color: #717798;
            }
        }
    }

    &__content {
        padding: 10px 0;

        &-tag {
            width: 100%;

            .tag-list {
                overflow: hidden;
                li {
                    float: left;
                    padding: 4px 6px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    border: 1px solid rgba(247, 247, 247, 1);
                    cursor: pointer;
                    @include font(rgba(89, 126, 247, 1), 14px, 400);

                    &:hover {
                        background-color: rgba(247, 247, 247, 1);
                    }

                    &.default {
                        color: rgba(89, 126, 247, 1);
                    }

                    &.green {
                        color: rgba(82, 196, 26, 1);
                    }

                    &.pink {
                        color: rgba(179, 127, 235, 1);
                    }

                    &.blue {
                        color: rgba(64, 169, 255, 1);
                    }
                }
            }
        }
    }
}

// 小屏
@include mq($small) {
    .aside-tag {

        &__title {
            height: 36px;

            &-text {
                @include font(rgba(39, 44, 64, 1), 14px, 600);
            }

            &-more {
                @include font(#c0c4cc, 12px, 400);
            }
        }

        &__content {
            &-tag .tag-list li {
                @include font(rgba(89, 126, 247, 1), 12px, 400);
            }
        }
    }
}
</style>
